/* ETC redesign Phase 2 — motion layer.
   Two behaviors: (1) blur-fade reveal on scroll, no library;
   (2) pinned scroll-scrubbed proof sequence, GSAP ScrollTrigger,
   desktop only. Hard prefers-reduced-motion guard here AND in
   etc-motion.css. This script only ever ADDS the html.etc-motion
   class — if it never runs, the site renders fully visible. */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var MOBILE = window.matchMedia('(max-width: 767px)').matches;

  document.documentElement.classList.add('etc-motion');

  /* ---------- 1. Blur-fade reveals ---------- */

  var SELECTORS = [
    '.slideshow-block--root .stacked-text--wrapper > *',
    '.featured-collections--heading',
    '.featured-collections--item',
    '.featured-collection--header',
    '.featured-collection--products .product-card--root',
    '.testimonials--header',
    '.testimonials--block',
    '.featured-grid--header',
    '.featured-grid--item',
    '.etc-proof--header',
    '.featured-text--wrapper .section-blocks--block > *'
  ];
  // On desktop the proof beats belong to the pinned sequence, not the
  // reveal system; on mobile they stack plainly and get the standard reveal.
  if (MOBILE) SELECTORS.push('.etc-proof--beat');

  var STEP = MOBILE ? 60 : 90; // stagger between siblings
  var CAP = 5;                 // stagger caps after ~5 items

  var targets = [];
  var groupIndex = new Map();

  SELECTORS.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.hasAttribute('data-etc-reveal')) return;
      var parent = el.parentNode;
      var i = groupIndex.get(parent) || 0;
      groupIndex.set(parent, i + 1);
      el.style.setProperty('--etc-d', Math.min(i, CAP) * STEP + 'ms');
      el.setAttribute('data-etc-reveal', '');
      targets.push(el);
    });
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('etc-in');
      io.unobserve(entry.target);
    });
  }, { threshold: 0.2 });

  targets.forEach(function (el) { io.observe(el); });

  // Fallback for instant jumps (anchor links, scroll restoration): an
  // element scrolled PAST never intersects, so the observer alone would
  // leave it invisible. On scroll/resize, reveal anything whose top is
  // above the viewport bottom. rAF-throttled; the list shrinks as
  // elements reveal, and listeners detach when it empties.
  var pending = targets.slice();
  var ticking = false;
  function sweep() {
    ticking = false;
    var vh = window.innerHeight;
    pending = pending.filter(function (el) {
      if (el.classList.contains('etc-in')) return false;
      if (el.getBoundingClientRect().top < vh) {
        el.classList.add('etc-in');
        io.unobserve(el);
        return false;
      }
      return true;
    });
    if (!pending.length) {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    setTimeout(sweep, 120);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  /* ---------- 2. Pinned proof sequence (desktop only) ---------- */

  function initProof() {
    var root = document.querySelector('.etc-proof--root');
    if (!root) return;
    // GSAP loads from CDN, deferred, only on templates containing the
    // section. If it failed to load, the static grid fallback stands.
    if (!(window.gsap && window.ScrollTrigger)) return;

    var beats = root.querySelectorAll('.etc-proof--beat');
    if (beats.length < 2) return;

    var gsap = window.gsap;
    gsap.registerPlugin(window.ScrollTrigger);

    // gsap.matchMedia (not a load-time check) so the pin sets up and tears
    // down on breakpoint or reduced-motion changes, not just at page load.
    var mm = gsap.matchMedia();
    mm.add('(min-width: 768px) and (prefers-reduced-motion: no-preference)', function () {
      // The pinned sequence owns the beats; the reveal system must not.
      beats.forEach(function (b) {
        b.removeAttribute('data-etc-reveal');
        b.classList.remove('etc-in');
      });
      root.classList.add('etc-proof--pinned');

      var dots = root.querySelectorAll('.etc-proof--dot');

      gsap.set(beats, { autoAlpha: 0, yPercent: 6 });
      gsap.set(beats[0], { autoAlpha: 1, yPercent: 0 });

      var tl = gsap.timeline({
        defaults: { ease: 'none', duration: 1 },
        scrollTrigger: {
          trigger: root,
          start: 'top top',
          end: '+=200%',
          pin: true,
          scrub: 0.4,
          onUpdate: function (st) {
            var active = Math.min(
              beats.length - 1,
              Math.floor(st.progress * beats.length)
            );
            dots.forEach(function (dot, i) {
              dot.classList.toggle('is-active', i === active);
            });
          }
        }
      });

      for (var i = 1; i < beats.length; i++) {
        tl.to(beats[i - 1], { autoAlpha: 0, yPercent: -6 }, '+=0.6')
          .to(beats[i], { autoAlpha: 1, yPercent: 0 }, '<');
      }
      tl.to({}, { duration: 0.6 }); // hold on the final beat before unpinning

      return function () {
        // matchMedia reverts the tweens and ScrollTrigger; we restore layout.
        root.classList.remove('etc-proof--pinned');
      };
    });
  }

  if (document.readyState === 'complete') {
    initProof();
  } else {
    // 'load' guarantees the deferred GSAP CDN scripts have executed and
    // images have dimensions, so ScrollTrigger measures correctly.
    window.addEventListener('load', initProof);
  }
})();
